import { render, staticRenderFns } from "./ChildUnderEvent.vue?vue&type=template&id=573a224c&scoped=true&"
import script from "./ChildUnderEvent.vue?vue&type=script&lang=js&"
export * from "./ChildUnderEvent.vue?vue&type=script&lang=js&"
import style0 from "./ChildUnderEvent.vue?vue&type=style&index=0&id=573a224c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a224c",
  null
  
)

export default component.exports